import React from 'react';
import get from 'lodash/get.js';
import { ProgressSpinner } from '../components/progress-spinner/component.js';

/* eslint-disable sonarjs/cognitive-complexity */
var renderContainerChildren = function renderContainerChildren(props, style) {
  var WrapperComponent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : React.Fragment;
  var children = props.children,
    _props$collection = props.collection,
    collection = _props$collection === undefined ? [] : _props$collection,
    currentEntity = props.currentEntity,
    isLoadingData = props.isLoadingData,
    hideLoader = props.hideLoader;
  var isCollectionEmpty = !collection.length;
  var isMemberSelected = !!currentEntity;
  var showLoading = false;
  var renderedChildren = React.Children.map(children, function (child) {
    if (!child) {
      return null;
    }
    var _ref = child.props || {},
      showIfCollectionEmpty = _ref.showIfCollectionEmpty,
      hideIfCollectionEmpty = _ref.hideIfCollectionEmpty,
      showIfMemberSelected = _ref.showIfMemberSelected,
      hideIfMemberSelected = _ref.hideIfMemberSelected,
      hideIfLoadingCollection = _ref.hideIfLoadingCollection,
      hideIfLoadingMember = _ref.hideIfLoadingMember;
    var isHidden = showIfCollectionEmpty && !isCollectionEmpty || hideIfCollectionEmpty && isCollectionEmpty || showIfMemberSelected && !isMemberSelected || hideIfMemberSelected && isMemberSelected || hideIfLoadingMember && isLoadingData || hideIfLoadingCollection && isLoadingData && isCollectionEmpty;
    if (isHidden) {
      showLoading = showLoading || isLoadingData;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'none'
        }
      }, child);
    } else if (style) {
      var type = child.type;
      var name = (typeof type === 'string' ? type : type.name).toLowerCase();
      return /*#__PURE__*/React.createElement("div", {
        style: style,
        className: "child-container-".concat(name)
      }, child);
    } else {
      return child;
    }
  });
  if (!renderedChildren || !renderedChildren.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(WrapperComponent, null, renderedChildren, showLoading && !hideLoader && /*#__PURE__*/React.createElement(ProgressSpinner, null));
};
renderContainerChildren.displayName = "renderContainerChildren";
var renderFields = function renderFields(props, renderWrapper) {
  var children = props.children,
    name = props.name,
    data = props.data,
    _props$errorMessages = props.errorMessages,
    errorMessages = _props$errorMessages === undefined ? {} : _props$errorMessages,
    activeLanguage = props.activeLanguage,
    onKeyDown = props.onKeyDown,
    onValueChange = props.onValueChange,
    runValidation = props.runValidation,
    scrollContainerId = props.scrollContainerId,
    valueChangeDelay = props.valueChangeDelay,
    languages = props.languages;
  return React.Children.map(children, function (child, index) {
    if (child) {
      var dataValue;
      var fieldName = child.props.multilingual ? "".concat(child.props.name, "_").concat(activeLanguage) : child.props.name;
      if (name) {
        fieldName = "".concat(name, "[").concat(fieldName, "]");
      }
      if (child.props.valueOverride && child.props.dataValue) {
        dataValue = child.props.dataValue;
      } else if (data) {
        dataValue = get(data, child.props.fieldName || fieldName);
      }
      var cloneProps = {
        dataValue: dataValue,
        onKeyDown: onKeyDown,
        onValueChange: onValueChange,
        valueChangeDelay: valueChangeDelay,
        runValidation: runValidation || child.props.runValidation,
        scrollContainerId: scrollContainerId,
        activeLanguage: activeLanguage,
        languages: languages,
        name: fieldName
      };
      if (child.props.name && errorMessages && errorMessages[child.props.name]) {
        cloneProps.errorMessage = errorMessages[child.props.name];
      }
      if (data) {
        cloneProps.data = data;
      }
      var renderedChild = /*#__PURE__*/React.cloneElement(child, cloneProps);
      if (renderWrapper) {
        return renderWrapper(renderedChild, index);
      }
      return renderedChild;
    }
  });
};
export { renderContainerChildren, renderFields };